import React, { useEffect, useState, useRef } from 'react';
import mainlogo from '../../Assets/images/main-logo.svg';
import loginImg from '../../Assets/images/login-img.webp';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LoginValidation from '../../Validation/LoginValidation';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import { deleteFromStorage, getFromStorage, handleBackspaceAndEnter, saveToStorage } from '../../utils/Helper';
import { LOGIN_DEBUG_SESSION_KEY, StorageConstant } from '../../constants/Constants';
import ResetPassword from '../../Modal/ResetPassword';
import { Config } from '../../config/Config';
import FrontLoader from '../layout/FrontLoader';
import AuthSubmitButton from '../layout/AuthSubmitButton';
import { LanguageConstants } from '../../constants/LanguageConstants';
import SocialLogin from '../layout/SocialLogin';
import LanguageDropdown from '../layout/LanguageDropdown';

interface FormInputs {
  email: string;
  password: string;
}

function Login() {
  const Login = useMakeRequest();
  const Forgot = useMakeRequest();
  const ResedOtp = useMakeRequest();
  const OTP = useMakeRequest();
  const numberOfDigits = 4;
  const regex = /^[0-9\b]+$/;
  const otpBoxRef = useRef<any>([]);
  const [forgotpopu, setForgotpopu] = useState(false);
  const [otppopu, setOtpPopu] = useState(false);
  const [resetPopu, setResetPopu] = useState(false);
  const [show, setShow] = useState(false);
  const [forgotemail, setForgotemail] = useState('');
  const [forgotEmailerror, setForgotemailerror] = useState('');
  const [otpData, setOtpData]: any = useState('');
  const [otpError, setOtpError] = useState('');
  const [otp, setOtp]: any = useState(new Array(numberOfDigits).fill(''));
  const [timer, setTimer] = useState(120);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  let countdown: any;
  const rememberMe = getFromStorage({ key: StorageConstant?.remember_me });

  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(LoginValidation),
  });

  const boxImageSrc = `${process.env.PUBLIC_URL || ''}/login/box image.png`;

  const onSubmit = (payload: FormInputs) => {
    const t0 = typeof performance !== 'undefined' ? performance.now() : Date.now();
    console.log('[Login][WEB FE] Form submit — API started (before makeRequest)', {
      ms: 0,
      email: payload.email,
      passwordLength: payload.password?.length,
      apiUrl: ApiConstants?.Login,
    });
    setResetPopu(false);
    setForgotpopu(false);
    setOtpPopu(false);
    setShow(false);
    Login.makeRequest({ payload, url: ApiConstants?.Login, toastStatus: true });
    console.log('[Login][WEB FE] Form submit — makeRequest enqueued', {
      ms: Math.round(((typeof performance !== 'undefined' ? performance.now() : Date.now()) - t0) * 100) / 100,
    });
  };
  const handelForgotEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!forgotemail) {
      setForgotemailerror(LanguageConstants?.FORGOT_EMAIL_REQUIRED);
    } else if (!emailRegex.test(forgotemail)) {
      setForgotemailerror(LanguageConstants?.FORGOT_EMAIL_INVALID);
    } else {
      const payload = {
        email: forgotemail,
      };
      Forgot.makeRequest({ payload, url: ApiConstants?.ForgotPassword, toastStatus: true });
    }
  };

  const onPaste = (event: any) => {
    const pasted = event.clipboardData.getData('text/plain');
    if (pasted.length === numberOfDigits && regex.test(pasted)) {
      setOtpError('');
      setOtpData(pasted);
      setOtp(pasted.split('').slice(0, numberOfDigits));
    }
  };
  const handleChange = (value: any, index: any) => {
    setOtpError('');
    if (value === '' || regex.test(value)) {
      const newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);
      setOtpData(newArr.join(''));
    }

    if (value && regex.test(value) && index < numberOfDigits - 1) {
      otpBoxRef.current[index + 1].focus();
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  const handleVerifyOtp = () => {
    if (otp.join('') === '' || otpData?.length < 4) {
      return setOtpError(LanguageConstants?.OTP_ENTER_ERROR);
    }
    setOtpError('');
    const payload = {
      email: forgotemail,
      otp: otpData,
      verify_type: 'FORGOT_PASSWORD',
    };
    OTP.makeRequest({ payload, url: ApiConstants?.VerifyOtp, toastStatus: true });
  };
  const handleShowChange = () => {
    setResetPopu(false);
    setForgotpopu(false);
    setOtpPopu(false);
    setShow(false);
  };

  useEffect(() => {
    if (Forgot.status) {
      setForgotemailerror('');
      setForgotpopu(false);
      setOtpPopu(true);
      setIsTimerRunning(false);
      setIsTimerRunning(true);
      setTimer(120);
      setOtp(new Array(numberOfDigits).fill(''));
      setOtpData('');
      setOtpError('');
    }
    if (OTP.status) {
      setForgotemailerror('');
      setOtpError('');
      setOtpPopu(false);
      setResetPopu(true);
    }
  }, [Forgot?.status, OTP?.status]);
  useEffect(() => {
    if (isTimerRunning && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(countdown);
      setIsTimerRunning(false);
    }
    return () => {
      clearInterval(countdown);
    };
  }, [isTimerRunning, timer, ResedOtp.status]);

  useEffect(() => {
    if (rememberMe) {
      setValue('email', rememberMe?.email ? rememberMe?.email : '');
      setValue('password', rememberMe?.password ? rememberMe?.password : '');
    }
    if (ResedOtp.status) {
      setIsTimerRunning(true);
      setTimer(120);
      setOtp(new Array(numberOfDigits).fill(''));
      setOtpData('');
      setOtpError('');
      window.setTimeout(() => otpBoxRef.current?.[0]?.focus?.(), 0);
    }
  }, [ResedOtp?.status]);

  useEffect(() => {
    console.log('[Login] hook state', {
      loading: Login?.loading,
      status: Login?.status,
      hasData: Login?.data != null,
      hasError: Login?.error != null,
      dataStatus: Login?.data?.status,
      dataStatusType: typeof Login?.data?.status,
      dataKeys: Login?.data && typeof Login?.data === 'object' ? Object.keys(Login.data) : [],
    });
  }, [Login?.loading, Login?.status, Login?.data, Login?.error]);

  useEffect(() => {
    if (Login?.status) {
      const apiData = Login?.data;
      const token = apiData?.access_token;

      console.groupCollapsed('[Login] SUCCESS — detail (console may clear on redirect; see next home load log)');
      console.log('apiData (full except long token)', {
        ...apiData,
        access_token: token && typeof token === 'string' ? `…len=${token.length} tail=${token.slice(-20)}` : token,
      });
      console.log('summary', {
        status: apiData?.status,
        status_code: apiData?.status_code,
        message: apiData?.message,
        has_access_token: Boolean(token),
        user_id: apiData?.data?.id,
        user_email: apiData?.data?.email,
        is_category_select: apiData?.data?.is_category_select,
      });
      console.groupEnd();

      setResetPopu(false);
      setForgotpopu(false);
      setOtpPopu(false);
      setShow(false);
      saveToStorage({ key: 'access_token', value: Login?.data?.access_token });
      saveToStorage({ key: 'user_data', value: Login?.data });

      const tokenAfter = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN });
      const userAfter = getFromStorage({ key: 'user_data' });
      const storageSnapshot = {
        has_token: Boolean(tokenAfter),
        has_user_data: Boolean(userAfter),
        user_id_from_storage: userAfter?.data?.id,
        tokenReadType: typeof tokenAfter,
      };
      console.log('[Login] after saveToStorage — logged in?', storageSnapshot);

      const persistPayload = {
        phase: 'success_before_redirect',
        at: new Date().toISOString(),
        redirectTo: `${Config?.BASE_URL}/`,
        note: 'Shown again on home after redirect (sessionStorage). Enable Preserve log to see pre-redirect logs.',
        api: {
          status: apiData?.status,
          status_code: apiData?.status_code,
          message: apiData?.message,
          topLevelKeys: apiData ? Object.keys(apiData) : [],
          user: apiData?.data
            ? {
                id: apiData.data.id,
                email: apiData.data.email,
                name: apiData.data.name,
                is_category_select: apiData.data.is_category_select,
              }
            : null,
          access_token_length: token && typeof token === 'string' ? token.length : null,
          access_token_tail: token && typeof token === 'string' ? token.slice(-24) : null,
        },
        storageAfterSave: storageSnapshot,
      };
      try {
        sessionStorage.setItem(LOGIN_DEBUG_SESSION_KEY, JSON.stringify(persistPayload));
      } catch (e) {
        console.warn('[Login] could not write LOGIN_DEBUG_SESSION_KEY', e);
      }

      console.log('[Login] redirect →', persistPayload.redirectTo);
      window.location.href = `${Config?.BASE_URL}/`;
    }
  }, [Login?.status]);

  useEffect(() => {
    if (Login?.loading || Login?.status) return;
    const err = Login?.error as any;
    if (err == null) return;

    const failPayload = {
      phase: 'login_failed',
      at: new Date().toISOString(),
      axiosMessage: err?.message,
      responseHttpStatus: err?.response?.status,
      responseData: err?.response?.data,
      rawErrorKeys: err && typeof err === 'object' ? Object.keys(err) : [],
      hookDataWhenFail: err && !(err as any)?.response ? err : undefined,
    };
    console.groupCollapsed('[Login] NOT logged in — detail');
    console.log('parsed failure', failPayload);
    console.groupEnd();
    try {
      sessionStorage.setItem(LOGIN_DEBUG_SESSION_KEY, JSON.stringify(failPayload));
    } catch (e) {
      console.warn('[Login] could not write fail debug to sessionStorage', e);
    }
  }, [Login?.error, Login?.loading, Login?.status]);

  const handelResendOtp = () => {
    setOtp(new Array(numberOfDigits).fill(''));
    setOtpData('');
    setOtpError('');
    const payload = {
      email: forgotemail,
      verify_type: 'FORGOT_PASSWORD',
    };
    ResedOtp.makeRequest({ payload, url: ApiConstants?.ResendOtp, toastStatus: true });
  };

  const handelRemberMe = () => {
    const check: any = document.getElementsByClassName('form-check-input');
    if (check?.rememberMe?.checked) {
      if (watch('email') && watch('password')) {
        const data = {
          email: watch('email'),
          password: watch('password'),
        };
        saveToStorage({ key: 'remember_me', value: data });
      }
    } else {
      deleteFromStorage({ key: 'remember_me' });
    }
  };

  return (
    <>
      {Forgot?.loading || ResedOtp?.loading || OTP?.loading ? <FrontLoader /> : null}
      <div className="auth-page auth-page--login">
        <div className="auth-split">
          <aside className="auth-promo" aria-hidden="false">
            <img className="auth-login-img-mobile" src={mainlogo} alt="" />
            <img className="auth-login-img" src={loginImg} alt="" />
          </aside>

          <div className="auth-form-wrap">
            <div className="auth-form-wrap-inner">
              <div className="auth-form-inner auth-form-inner-card">
                <h1 className="auth-title">{LanguageConstants?.LOGIN}</h1>
                <p className="auth-head-para">{LanguageConstants?.ENTER_YOUR_LOGIN_DETAILS}</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="com-input-wrap mb-3 mb-xxl-4">
                    <label className="form-label" htmlFor="login_email">
                      {LanguageConstants?.LOGIN_EMAIL_ADDRESS}
                    </label>
                    <input
                      id="login_email"
                      className="form-control"
                      type="email"
                      placeholder={LanguageConstants?.LOGIN_EMAIL_ADDRESS_TEXT}
                      autoComplete="email"
                      {...register('email')}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="email"
                      render={({ message }) => <p className="input-error">{message}</p>}
                    />
                  </div>

                  <div className="com-input-wrap mb-3 mb-xxl-4">
                    <label className="form-label" htmlFor="login_password">
                      {LanguageConstants?.PASSWORD}
                    </label>
                    <div className="position-relative">
                      <input
                        id="login_password"
                        className="form-control"
                        type={show ? 'text' : 'password'}
                        placeholder={LanguageConstants?.PASSWORD}
                        autoComplete="current-password"
                        {...register('password')}
                      />
                      <i
                        className={show ? 'f-pass icon-eye-open' : 'f-pass icon-eye-slash-fill'}
                        onClick={() => setShow(!show)}
                        role="presentation"
                      />
                    </div>
                    <ErrorMessage
                      errors={errors}
                      name="password"
                      render={({ message }) => <p className="input-error">{message}</p>}
                    />
                  </div>

                  <div className="form-label-area mb-3 mb-xxl-4">
                    <div className="form-check" onClick={(e: any) => handelRemberMe()}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="rememberMe"
                        defaultChecked={rememberMe ? true : false}
                      />
                      <label className="form-check-label" htmlFor="rememberMe">
                        {LanguageConstants?.REMEBER_ME}
                      </label>
                    </div>
                    <button className="auth-modal-btn" type="button" onClick={() => setForgotpopu(true)}>
                      {LanguageConstants?.FORGOT_PASSWORD}?
                    </button>
                  </div>

                  <AuthSubmitButton className="w-100" loading={Login?.loading}>
                    {LanguageConstants?.LOGIN}
                  </AuthSubmitButton>
                  <div className="small-txt text-center mt-3">
                    {LanguageConstants?.GUEST_USER}{' '}
                    <Link to={'/'} className="theme-color">
                      {LanguageConstants?.GUEST}
                    </Link>
                  </div>
                  <div className="auth-or my-2" aria-hidden="true">
                    <span>{LanguageConstants?.OR_CONNECTOR}</span>
                  </div>
                  <SocialLogin loginGoogleAppleRow />
                  <div className="small-txt text-center mt-3">
                    {LanguageConstants?.LOGIN_MESSAGE}{' '}
                    <Link to={'/signup'} className="theme-color">
                      {LanguageConstants?.SINGUP}
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer className="auth-footer">
          <div className="auth-footer__lang">
            <LanguageDropdown instanceId="langDropdownLogin" />
          </div>
          <div className="auth-footer__copy">{LanguageConstants?.COPYRIGHT}</div>
          <div className="auth-footer__legal">
            <Link to="/cms/privacy-policy">{LanguageConstants?.PRIACYPOLICY}</Link>
            <Link to="/cms/terms-and-conditions">{LanguageConstants?.TERMS}</Link>
          </div>
        </footer>
      </div>

      <Modal show={forgotpopu}>
        <div
          className="modal fade auth-modal text-center show"
          id="forgotPassModal"
          aria-labelledby="forgotPassModalLabel"
          aria-hidden="false"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button
                type="button"
                onClick={() => {
                  setForgotpopu(false);
                  setForgotemail('');
                }}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="icon-close-square" />
              </button>
              <div className="modal-body">
                <h5 className="auth-modal-ttl">{LanguageConstants?.FORGOT_PASSWORD}</h5>
                <div className="mb-4">
                  <div className="com-floating">
                    <i className="f-icon icon-msg" />
                    <label className="f-label">{LanguageConstants?.LOGIN_EMAIL_ADDRESS}</label>
                    <input
                      className="f-input ps-5"
                      type="email"
                      placeholder={LanguageConstants?.LOGIN_EMAIL_ADDRESS_TEXT}
                      onChange={(e) => setForgotemail(e?.target?.value)}
                    />
                  </div>
                  <p className="text-error text-start">{forgotEmailerror}</p>
                </div>
                <button
                  type="button"
                  disabled={Forgot.loading ? true : false}
                  onClick={() => handelForgotEmail()}
                  className="round-btn w-100 mt-5"
                  data-bs-dismiss="modal"
                >
                  {LanguageConstants?.SEND_OTP}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal show={otppopu}>
        <div
          className="modal fade auth-modal text-center show"
          id="forgotPassModal"
          aria-labelledby="forgotPassModalLabel"
          aria-hidden="false"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button
                type="button"
                onClick={() => {
                  setOtpPopu(false);
                  setForgotemail('');
                }}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="icon-close-square" />
              </button>
              <div className="modal-body">
                <h5 className="auth-modal-ttl mb-2">{LanguageConstants?.OTP_VERIFICATION}</h5>
                <p className="auth-modal-small-txt">
                  {LanguageConstants?.ENTER_OTP_DIGIT} ****{forgotemail?.split('@')[1]}
                </p>
                <div className="otp-inputs">
                  {otp.map((digit: any, index: any) => {
                    return (
                      <input
                        className="form-control"
                        key={index}
                        value={digit}
                        onPaste={onPaste}
                        maxLength={1}
                        ref={(ref) => (otpBoxRef.current[index] = ref)}
                        type="text"
                        placeholder="*"
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={handleKeyDown}
                        onKeyUp={(e) => handleBackspaceAndEnter(e, index, otpBoxRef, numberOfDigits)}
                      />
                    );
                  })}
                </div>
                <p style={{ color: 'red' }}>{otpError}</p>
                <p className="auth-modal-small-txt mb-2">{LanguageConstants?.DONT_RECIVE_CODE}?</p>
                {isTimerRunning ? (
                  <div className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4">
                    {LanguageConstants?.RESEND_IN} :{timer} s
                  </div>
                ) : (
                  <button
                    type="button"
                    className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4"
                    onClick={() => handelResendOtp()}
                  >
                    {LanguageConstants?.RESEND_OTP}
                  </button>
                )}
                <button
                  type="button"
                  disabled={OTP.loading ? true : false}
                  onClick={handleVerifyOtp}
                  className="auth-modal-btn round-btn mt-4 w-50 d-block mx-auto"
                  data-bs-dismiss="modal"
                >
                  {LanguageConstants?.VERIFY}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal show={resetPopu}>
        <ResetPassword email={forgotemail} OTP={otp} setShowFalse={handleShowChange} />
      </Modal>
    </>
  );
}

export default Login;
